import {Disclosure} from '@headlessui/react';
import React, {FC, ReactNode} from "react";
import Link from 'next/link';

export type FAQItems = {
  question: string;
  answer: string;
}

interface FAQProps {
  title?: string;
  enableHeading?: boolean;
  faqs: FAQItems[];
  anchor?: string;
  children?: ReactNode | ReactNode[];
}

const FAQ: FC<FAQProps> = ({
  title,
  enableHeading,
  faqs,
  anchor,
  children
}) => {
  return (
    <div
      className="bg-gray-50"
      id={!!anchor && anchor}
    >
      <div className="mx-auto max-w-7xl py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        {!!title && (
          <span className="block text-[#ff6600] font-bold tracking-wide leading-6 uppercase text-center">{title}</span>
        )}
        <div className="mx-auto max-w-7xl divide-y-2 divide-gray-200">
          {enableHeading && (
            <h2 className="text-center text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Frequently asked <span className="text-[#400068]">questions</span>
            </h2>
          )}
          <dl className="mt-6 space-y-6 divide-y divide-gray-200">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({open}) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-400">
                        <span className="font-medium text-gray-900">{faq.question}</span>
                        <span className="ml-6 flex h-7 items-center">
                          {/*<ChevronDownIcon*/}
                          {/*  className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform')}*/}
                          {/*  aria-hidden="true"*/}
                          {/*/>*/}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base text-gray-500">{faq.answer}</p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}

export default FAQ
